export default class ExecutionQueue {
  private queue: (() => boolean)[];
  private isOff: boolean;
  private pollTimerId: NodeJS.Timer | null;

  constructor() {
    this.queue = [];
    this.isOff = false;
    this.pollTimerId = setInterval(() => {
      if (this.isOff) {
        // process the queue for the last time
        if (this.pollTimerId) {
          clearInterval(this.pollTimerId as unknown as number);
          this.pollTimerId = null;
        }
      }

      if (this.queue.length > 0) {
        const q = [...this.queue];
        this.queue.length = 0; // clear the queue
        q.forEach((task) => {
          if (!task()) {
            // return the task that can't be executed now back to the queue to execute it later
            this.add(task);
          }
        });
      }
    }, 500);
  }

  public add(task: () => boolean): void {
    if (this.pollTimerId === null) {
      throw new Error("Queue is off and can't get any more tasks");
    }

    this.queue.push(task);
  }

  public off(): void {
    this.isOff = true;
  }
}
